<template>
    <div>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="7" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search"/>
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage"/>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table
                show-empty
                empty-text="You don't have any notifications"
                striped
                responsive
                stacked="md"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                @filtered="onFiltered"
        >
            <template v-slot:cell(data)="row">
                {{ row.item.data['title'] + ' by ' + row.item.data['from']}}
            </template>
            <template v-slot:cell(created_at)="row">
                {{ moment(row.item.created_at).format('MMM DD YYYY') }}
            </template>
            <template v-slot:cell(read_at)="row">
                <div v-if="row.item.read_at">{{ moment(row.item.read_at).format('MMM DD YYYY') }}</div>
                <div v-else class="text-success">Unread</div>
            </template>
        </b-table>
        <b-row>
            <b-col md="6" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"/>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    const items = [];
    var moment = require("moment");
    export default {
        props: ["notifications"],
        data() {
            return {
                moment: moment,
                items: this.notifications,
                fields: [
                    {
                        key: "data",
                        label: "Notification"
                    },
                    {
                        key: "created_at",
                        label: "Received"
                    },
                    {
                        key: "read_at",
                        label: "Read"
                    },
                ],
                currentPage: 1,
                perPage: 25,
                totalRows: this.notifications.length,
                pageOptions: [15, 25, 35, 50],
                filter: null,
                sortBy: "created_at",
                sortDesc: true
            };
        },
        computed: {
            sortOptions() {
                // Create an options list from our fields
                return this.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return {
                            text: f.label,
                            value: f.key
                        };
                    });
            }
        },
        filters: {
            uppercase: function (v) {
                return v.toUpperCase();
            }
        },
        methods: {
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
        }
    };
</script>

<!-- table-complete-1.vue -->